import { useCallback } from 'react';

/**
 * Hook to manage bulk selection operations for clothing items
 */
function useBulkSelection({
  selectedItems,
  setSelectedItems,
  setIsBulkSelectMode,
  setIsBulkDeleteModalOpen,
  setIsAddToClosetModalOpen,
  clothingItems
}) {
  const handleItemSelect = useCallback((itemId) => {
    setSelectedItems(prev => {
      if (prev.includes(itemId)) {
        return prev.filter(id => id !== itemId);
      } else {
        return [...prev, itemId];
      }
    });
  }, [setSelectedItems]);

  const handleAddToCloset = useCallback(() => {
    if (selectedItems.length > 0) {
      setIsAddToClosetModalOpen(true);
    }
  }, [selectedItems, setIsAddToClosetModalOpen]);

  const handleBulkDelete = useCallback(() => {
    if (selectedItems.length > 0) {
      setIsBulkDeleteModalOpen(true);
    }
  }, [selectedItems, setIsBulkDeleteModalOpen]);

  const handleBulkDeleteSuccess = useCallback((result) => {
    console.log('[Bulk] Bulk delete successful:', result);
    // Clear selection and exit bulk mode
    setSelectedItems([]);
    setIsBulkSelectMode(false);
  }, [setSelectedItems, setIsBulkSelectMode]);

  const handleSelectAll = useCallback(() => {
    if (clothingItems && clothingItems.length > 0) {
      const allIds = clothingItems.map(item => item.id);
      setSelectedItems(allIds);
    }
  }, [clothingItems, setSelectedItems]);

  const handleUnselectAll = useCallback(() => {
    setSelectedItems([]);
  }, [setSelectedItems]);

  return {
    handleItemSelect,
    handleAddToCloset,
    handleBulkDelete,
    handleBulkDeleteSuccess,
    handleSelectAll,
    handleUnselectAll
  };
}

export default useBulkSelection;
